/*
 * This component shows a few high-level results for a fund for an issue.
 *
 * fund score for issue
 * fund rank for issue
 * fund grade for issue
 *
 */
import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
  Grade
} from '../'
import Styles from './FundIssueReportCard.css'

@CSSModules(Styles, {allowMultiple:true})
export default class FundIssueReportCard extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
    fund: PropTypes.object.isRequired,
    sjfFund: PropTypes.object,
  }
  constructor(props){
    super(props);
    // unpack _score, _grade, _grp_nrm, _grp
    // + fund.category_group
    //
    // load normalizers (group) from config
    //
    const gradeLabels = {
      gef: 'gender_equality',
      dei: 'dei',
      rji: 'rji',
      hrc: 'hrc',
    }
    const score = props.fund[props.issueId+'_score']
    const grpNrm = props.fund[props.issueId+'_grp_norm']
    const grade = props.fund['grade_'+gradeLabels[props.issueId]]

    const _f = props.issueId==='gef' ?
      props.fund :
      props.sjfFund

    const categoryGroup = props.fund.category_group
    const denominator = config[props.issueId+'ScoreNormalizers'].groups[categoryGroup]
    const grp = denominator - _f[props.issueId+'_grp'] + 1
    const categoryUrl = config.routes.list + '?grp=' + encodeURIComponent(categoryGroup)

    this.state = {
      grade,
      score,
      grpNrm,
      grp,
      categoryGroup,
      denominator,
      categoryUrl
    }
  }
  //
  render() {
    if (this.state.grade === 2.5) {
      return null
    }

    return <div styleName='fund-issue-report-card'>

      <div styleName='fund-issue-report-card__col'>
        <div styleName='fund-issue-report-card__col-title'>
          Score
        </div>
        <div styleName='fund-issue-report-card__results'>
          { /* CHECK IF UNSCORED (ZERO COVERAGE) */
            parseFloat(this.state.score) === config.sjfNullSentinel ?
              <div>
                <span styleName='fund-issue-report-card__score'>UNSCORED</span>
                <br/>
                <p style={{'textAlign':'center'}}>
                  <small>Fund is below coverage threshold</small>
                </p>
              </div> :
              <span styleName='fund-issue-report-card__score'>
                {format.number(this.state.score)} <span styleName='fund-issue-report-card__out-of'>/ 100</span>
              </span>
          }
        </div>
      </div>

      <div styleName='fund-issue-report-card__col'>
        <div styleName='fund-issue-report-card__col-title'>
          Rank
        </div>
        <div styleName='fund-issue-report-card__results'>
          <div>
            { /* CHECK IF UNRANKED (<33% COVERAGE) */
              parseFloat(this.state.grpNrm) === config.sjfNullSentinel ?
                <p>
                  <span styleName='fund-issue-report-card__score'>UNRANKED</span>
                </p> :
                <p>
                  <span styleName='fund-issue-report-card__score'>
                    { parseFloat(this.state.grpNrm).toFixed(1) }
                  </span> percentile
                </p>
            }
            { /* CHECK IF UNRANKED (<33% COVERAGE) */
              parseFloat(this.state.grpNrm) === config.sjfNullSentinel ?
                null :
                <p>
                  <i>Group:</i> <Link
                    to={this.state.categoryUrl}
                    xstrong
                  >{this.state.categoryGroup}</Link>
                </p>
            }
            { /* CHECK IF UNRANKED (<33% COVERAGE) */
              parseFloat(this.state.grpNrm) === config.sjfNullSentinel ?
                <p style={{'textAlign':'center'}}>
                  <small>Fund is below coverage threshold</small>
                </p> :
                <p>
                  <i>Rank:</i> #{format.number(this.state.grp)} out
                  of {format.number(this.state.denominator)}
                </p>
            }
          </div>
        </div>
      </div>

      <div styleName='fund-issue-report-card__col'>
        <div styleName='fund-issue-report-card__col-title'>
          Grade
        </div>
        <div styleName='fund-issue-report-card__results'>
          <div styleName='fund-issue-report-card__grade-wrap'>
            <Grade grade={this.state.grade} square />
          </div>
        </div>
      </div>

    </div>
  }
}